import React from "react";
import { MessageSquareText } from "lucide-react";
import { LegalPage } from "./LegalPage";

/* /sms-terms — SMS 项目条款（A2P 10DLC / 运营商审核要求的全部披露） */
export default function SmsTerms() {
  return (
    <LegalPage title="SMS Terms & Conditions" titleZh="短信服务条款" icon={MessageSquareText} testid="sms-terms-page">
      {(zh, co) => zh ? (
        <>
          <h2>1. 项目说明</h2>
          <p>{co.brand}（{co.brandZh}，法定实体 {co.legal}）向已同意接收短信的客户、业主、分包商及求职者发送与其项目 / 业务相关的<strong>交易与客服类</strong>短信，包括：预约与现场踏勘提醒、报价 / 合同签署链接、许可与施工进度更新、付款与收款通知、资料补交提醒、面试与入职通知。</p>
          <h2>2. 如何同意（Opt-in）</h2>
          <p>您可通过以下任一方式同意接收短信：在我们的网页表单（合同签署页、分包商资料填报页、招聘申请页）勾选「同意接收短信」；在签署服务协议时书面同意；或在咨询过程中口头 / 书面向我们的顾问提供手机号并同意接收短信。<strong>同意接收短信不是购买任何产品或服务的条件。</strong></p>
          <h2>3. 频率与费用</h2>
          <p>短信发送频率视项目进度而定（通常每月数条）。<strong>可能产生短信及数据流量费用</strong>，以您的运营商资费为准。</p>
          <h2>4. 退订与帮助</h2>
          <ul>
            <li>回复 <strong>STOP</strong> 可随时退订，之后您将收到一条确认短信，不再收到本项目短信。</li>
            <li>回复 <strong>HELP</strong> 获取帮助，或致电 {co.phone} / 邮件 {co.email}。</li>
            <li>退订后如需重新接收，回复 <strong>START</strong> 或联系您的项目顾问。</li>
          </ul>
          <h2>5. 隐私</h2>
          <p>我们不会为营销 / 推广目的向第三方或关联方出售、出租或分享您的手机号码及短信同意信息。详见 <a href="/privacy" className="text-red-600 underline">隐私政策</a>。</p>
          <h2>6. 运营商免责</h2>
          <p>运营商对延迟或未送达的短信不承担责任。支持美国主要运营商（AT&T、T-Mobile、Verizon 等）。</p>
          <h2>7. 联系我们</h2>
          <p>{co.legal} · {co.address} · {co.phone} · {co.email}</p>
        </>
      ) : (
        <>
          <h2>1. Program Description</h2>
          <p>{co.brand} (legal entity: {co.legal}) sends <strong>transactional and customer-care</strong> text messages to customers, homeowners, subcontractors and job applicants who have opted in. Messages relate to your project or business with us and include: appointment and site-visit reminders, quote / estimate and contract-signing links, permit and construction progress updates, payment and receipt notices, document requests, and interview / onboarding notices.</p>
          <h2>2. How You Opt In</h2>
          <p>You consent to receive SMS by any of the following: checking the “I agree to receive SMS” box on one of our web forms (contract-signing page, vendor onboarding page, careers application); agreeing in writing when signing a service agreement; or providing your mobile number and agreeing verbally / in writing to our consultant during a consultation. <strong>Consent to receive text messages is not a condition of purchasing any goods or services.</strong></p>
          <h2>3. Message Frequency & Cost</h2>
          <p>Message frequency varies based on your project activity (typically a few messages per month). <strong>Message and data rates may apply.</strong> Check with your mobile carrier for details.</p>
          <h2>4. Opt-Out & Help</h2>
          <ul>
            <li>Reply <strong>STOP</strong> at any time to cancel. You will receive one confirmation message and no further messages from this program.</li>
            <li>Reply <strong>HELP</strong> for help, call {co.phone}, or email {co.email}.</li>
            <li>To re-subscribe after opting out, reply <strong>START</strong> or contact your project consultant.</li>
          </ul>
          <h2>5. Privacy</h2>
          <p>We do not sell, rent or share your mobile number or SMS consent with third parties or affiliates for marketing or promotional purposes. See our <a href="/privacy" className="text-red-600 underline">Privacy Policy</a> for details.</p>
          <h2>6. Carrier Disclaimer</h2>
          <p>Carriers are not liable for delayed or undelivered messages. Supported on major U.S. carriers including AT&T, T-Mobile and Verizon.</p>
          <h2>7. Contact</h2>
          <p>{co.legal} · {co.address} · {co.phone} · {co.email}</p>
        </>
      )}
    </LegalPage>
  );
}
